<template>
  <div class="app-container bj-label-colon">
    <BjDivider
      >{{ $t('BusinessStockSynchronizationDetail.basicInformation') }}
      <template v-slot:right>
        <el-button @click="handleClose">{{ $t('backText') }}</el-button>
      </template>
    </BjDivider>

    <el-form>
      <el-row>
        <el-col :span="8">
          <el-form-item :label="$t('BusinessStockSynchronizationDetail.adjustCode')">
            {{ info.adjustCode }}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('BusinessStockSynchronizationDetail.warehouseCode')">
            {{ info.warehouseCode }}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('BusinessStockSynchronizationDetail.warehouseName')">
            {{ info.warehouseName }}
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item :label="$t('table.remarkText')">
            {{ info.remarks }}
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <BjDivider>{{ $t('BusinessStockSynchronizationDetail.commodityDetails') }}</BjDivider>
    <el-table
      ref="multipleTable"
      :data="info.adjustDetailResVOList"
      stripe
      border
      :header-cell-style="$rowStyle.DEFAULT"
      row-key="BJ_EBC_ID"
    >
      <el-table-column type="index" width="60" align="center" :label="$t('table.countText')" />
      <el-table-column prop="categoryName" align="center" :label="$t('goodsPage.categoryName')" />
      <!-- <el-table-column prop="spuCode" align="center" :label="$t('goodsPage.spuCode')" />
      <el-table-column prop="spuName" align="center" :label="$t('goodsPage.spuName')" /> -->
      <el-table-column prop="skuCode" align="center" :label="$t('goodsPage.skuCode')" />
      <el-table-column prop="realityNum" align="center" :label="$t('BusinessStockSynchronizationDetail.realityNum')" />
      <el-table-column prop="planNum" align="center" :label="$t('BusinessStockSynchronizationDetail.planNum')" />
    </el-table>
  </div>
</template>
<script>
import viewMiXin from '@/utils/view-mixin.js';
import { stockApi } from '@/api';

export default {
  name: 'BusinessStockSynchronizationDetail',
  mixins: [viewMiXin],
  data() {
    return {
      info: {
        adjustCode: null,
        warehouseCode: null,
        warehouseName: null,
        adjustDetailResVOList: [],
        remarks: null,
      },
    };
  },
  computed: {},
  mounted() {
    this.getData();
  },
  methods: {
    handleClose() {
      this.complete('BusinessStockSynchronization');
    },
    getData() {
      stockApi
        .getAdjustRecordsDetail({
          adjustId: this.$route.query.adjustId,
        })
        .then(res => {
          this.info = res;
        });
    },
  },
};
</script>
